import React, { ReactNode, CSSProperties } from "react"
import { TextField, FlatButton, Toggle, Card, CardHeader, CardText, CircularProgress, SelectField, MenuItem } from "material-ui"
import { red500 } from "material-ui/styles/colors"
import strings from "../../../localization/strings"
import PositionSelector from "../../../components/position/PositionSelector"
import AuthenticationStore from "../../../stores/AuthenticationStore"
import AccountStore from "../../../stores/AccountStore"
import AppStateStore from "../../../stores/AppStateStore"
import SetPasswordDialog from "./SetPasswordDialog"
import autobind from "class-autobind"
import PayrollSelection from "../../../components/payroll/PayrollSelection"
import EditPayrollSettingsDialog from "../../../components/payroll/EditPayrollSettingsDialog"
import ImageLoader from "../../../components/misc/ImageLoader"
import MultiSupervisorChips from "../../../components/supervisor/MultiSupervisorChips"
import { IDate, ELoggedInUserType, IUserDocument, IPosition, IJobPhase, IJobDocument, IPrivacyAgreementDocument, IHierarchyItem, IEmployeeHRDocument, IUIUser, ELanguage, IUserPayrollData } from "../../../models"
import * as utils from "../../../helpers/utils"
import * as timeHelper from "../../../helpers/timeHelper"
import * as userActions from "../../../actions/UserActions"
import * as userHelper from "../../../helpers/userHelper"
import * as hieararchyHelper from "../../../helpers/hierarchyHelper"
import * as api from "../../../api"
import _ from "lodash"
import * as payGroupAndTypeHelper from "../../../helpers/payGroupAndTypeHelper"
import AgreementAcceptStatus from "../../../components/agreement/AgreementAcceptStatus"
import ChooseHierarchyChip from "../../../components/hierarchy/choose_hierarchy/ChooseHierarchyChip"
import ChooseHierarchyJobPhaseChipForPunch from "../../../components/hierarchy/choose_hierarchy/ChooseHierarchyJobPhaseChipForPunch"
import AccountUserSettingsDialog from "../../../components/user/AccountUserSettingsDialog"
import moment from "moment"
import * as permissionHelper from "../../../helpers/permissionHelper"
import LanguageSelector from "../../../components/language/LanguageSelector"
import { checkPositionFieldAvailable } from "../../../helpers/positionHelper"
import { checkPhaseFieldAvailable } from "../../..//helpers/punchHelper"
import { checkJobFieldAvailable } from "../../../helpers/jobHelper"
interface IProps {
	user: IUserDocument
	readonly: boolean
	loggedInUserType: ELoggedInUserType
}
interface IState {
	id: string
	firstName: string
	firstNameErrorText: string
	lastName: string
	lastNameErrorText: string
	externalId: string
	clockPin: string
	defaultPositionId: string
	errorDefaultPositionId: string
	defaultHierarchyItemId: string
	defaultPunchHierarchyId: string
	errorDefaultPunchHierarchyId?: string
	defaultPunchJob: IJobDocument
	defaultPunchPhase: IJobPhase
	requirePhase: boolean
	Active: boolean
	userPositions: IPosition[]
	positions: IPosition[],
	clockPinErrorText: string
	externalIdErrorText: string
	allowSelfServiceLogin: boolean
	email: string
	emailErrorText: string
	password: string
	showSetPasswordDialog: boolean
	payrollHierarchyItemId: string
	payrollPayGroupId: string
	payrollPayGroupManualSet: boolean
	supervisorIds: string[]
	errorSupervisor: string
	allowPunchFromPersonalDevice: boolean
	allowHonorTimeEntry: boolean
	assignJobPunch: boolean
	userFormWidth: number
	loading: boolean
	isAccountUser: boolean
	openAccountUserSettingDialog: boolean
	userRoleId: string
	organizationHierarchyId: string
	latestFinddPrivacyPolicy: IPrivacyAgreementDocument
	latestAccountAgreement: IPrivacyAgreementDocument
	scheduleRanking: number
	expandedCardTitle: string
	hireDate: string
	fullTime: boolean
	agency: boolean
	float: boolean
	perDiem: boolean
	fetchingEmployeeHRUser: boolean
	isFetchedEmployeeHRUser: boolean
	terminationDate: IDate
	rehireDate: IDate
	seniorityDate: IDate
	startDate: IDate
	field1: string
	field2: string
	field3: string
	field4: string
	userModified: boolean
	otPolicyId: string
	otPolicyIdError: boolean
	otPolicyManualSet: boolean
	language: ELanguage
	enableBreadcrumb: boolean
	FTERatio: string
	requireBio: boolean
	AllowMobileTimecardView: boolean
	AllowMobileWorkView: boolean
	AllowMobileScheduleView: boolean
	AllowMobileLeaveTrackingView: boolean
	AllowMobileExpensesView: boolean
	ESSWallet: boolean
	AllowMobileAdHocFilesView: boolean
	applyAutoBreaks: boolean,
	AllowGeoFenceNotifications: boolean
	openEditPayrollSettingsDialog: boolean
}

export default class UserForm extends React.Component<IProps, IState> {
	private ChooseHierarchyJobPhaseChipForPunch
	private defaultPasword = "guid"
	private clockPinRegExp = /^\d+$/
	private canSetDefaultPassword
	private ChooseDefaultHierarchyItemChip
	constructor(props: IProps) {
		super(props)
		const allowSelfServiceLogin = permissionHelper.hasSpecificPermission(AuthenticationStore.SpecialPermission.SelfService, props.user)
		this.state = {
			loading: true,
			id: props.user.Id || "",
			firstName: props.user.FirstName || "",
			firstNameErrorText: "",
			lastName: props.user.LastName || "",
			lastNameErrorText: "",
			externalId: props.user.ExternalId || "",
			clockPin: props.user.ClockPin || "",
			defaultPositionId: props.user.DefaultPositionId,
			errorDefaultPositionId: "",
			defaultHierarchyItemId: props.user.DefaultHierarchyItemId,
			defaultPunchHierarchyId: props.user.DefaultPunchHierarchyId,
			defaultPunchJob: null,
			defaultPunchPhase: null,
			requirePhase: props.user ? props.user.RequirePhase : false,
			Active: props.user ? props.user.Active : false,
			userPositions: props.user ? props.user.Positions : [],
			positions: [],
			clockPinErrorText: "",
			externalIdErrorText: "",
			allowSelfServiceLogin,
			email: props.user && props.user.Email ? props.user.Email : "",
			emailErrorText: "",
			password: "",
			showSetPasswordDialog: false,
			payrollHierarchyItemId: props.user.PayrollHierarchyItemId,
			payrollPayGroupId: props.user.PayrollPayGroupId,
			payrollPayGroupManualSet: props.user.PayrollPayGroupManualSet,
			supervisorIds: props.user.SupervisorIds,
			errorSupervisor: "",
			allowPunchFromPersonalDevice: props.user ? props.user.AllowPunchFromPersonalDevice : true,
			allowHonorTimeEntry: props.user ? props.user.AllowHonorTimeEntry : false,
			assignJobPunch: props.user && props.user.AssignJobPunch ? true : false,
			userFormWidth: 100,
			isAccountUser: props.user ? props.user.AccountUser : false,
			openAccountUserSettingDialog: false,
			organizationHierarchyId: props.user ? props.user.OrganizationHierarchyId : null,
			userRoleId: props.user ? props.user.UserRoleId : null,
			latestFinddPrivacyPolicy: null,
			latestAccountAgreement: null,
			scheduleRanking: props.user ? props.user.ScheduleWeight : 0,
			expandedCardTitle: null,
			hireDate: props.user && props.user.HireDate ? props.user.HireDate : null,
			fullTime: props.user.FullTime,
			agency: props.user.Agency,
			float: props.user.Float,
			perDiem: props.user.PerDiem,
			fetchingEmployeeHRUser: false,
			isFetchedEmployeeHRUser: false,
			terminationDate: null,
			rehireDate: null,
			seniorityDate: null,
			startDate: null,
			field1: props.user.Field1 || "",
			field2: props.user.Field2 || "",
			field3: props.user.Field3 || "",
			field4: props.user.Field4 || "",
			userModified: props.user.UserModified,
			otPolicyId: AccountStore.getEnableOTPolicy() && props.user ?
				props.user.OTPolicyId :
				null,
			otPolicyIdError: false,
			otPolicyManualSet: AccountStore.getEnableOTPolicy() && props.user && props.user.OTPolicyId ? true : false,
			language: props.user.Language,
			enableBreadcrumb: props.user.EnableBreadcrumb,
			FTERatio: props.user.FTEFactor.toString(),
			requireBio: props.user.RequireBio,
			AllowMobileTimecardView: props.user.AllowMobileTimecardView,
			AllowMobileWorkView: props.user.AllowMobileWorkView,
			AllowMobileScheduleView: props.user.AllowMobileScheduleView,
			AllowMobileLeaveTrackingView: props.user.AllowMobileLeaveTrackingView,
			AllowMobileExpensesView: props.user.AllowMobileExpensesView,
			ESSWallet: props.user.ESSWallet,
			AllowMobileAdHocFilesView: props.user.AllowMobileAdHocFilesView,
			applyAutoBreaks: props.user.ApplyAutoBreaks,
			AllowGeoFenceNotifications: props.user.AllowGeoFenceNotifications,
			openEditPayrollSettingsDialog: false,
		}
		this.canSetDefaultPassword = !props.user.AccountUser && props.loggedInUserType !== ELoggedInUserType.Employee && !allowSelfServiceLogin
		autobind(this)
	}

	componentDidMount() {
		this.getDefaultJob()
		this.updateDimensions()
		this.getLatestPolicies()
		window.addEventListener("resize", this.updateDimensions);
	}

	componentWillReceiveProps(nextProps: IProps) {
		this.props.user.UserModified !== nextProps.user.UserModified &&
			this.setState({ userModified: nextProps.user.UserModified })
	}

	componentWillUnmount() {
		window.removeEventListener("resize", this.updateDimensions);
	}

	componentDidUpdate() {
		if (this.state.expandedCardTitle === strings.User_Information && !this.state.isFetchedEmployeeHRUser && AccountStore.getHREnabled()) {
			this.getEmployeeHRUser(this.props.user.Id)
		}
	}

	getLatestPolicies() {
		api.getLatestPrivacy().then(res => this.setState({ latestFinddPrivacyPolicy: res.data }))
		api.getLatestPrivacy(AccountStore.getCurrentAccount().Id).then(res => this.setState({ latestAccountAgreement: res.data }))
	}

	updateDimensions() {
		this.setState({ userFormWidth: document.getElementById("UserForm").clientWidth })
	}

	getDefaultJob() {
		if (this.props.user.DefaultJobId) {
			api.getJob(this.props.user.DefaultJobId).then(res =>
				this.setState({
					defaultPunchJob: res.data,
					defaultPunchPhase: res.data.Phases.find(phase => phase.Id === this.props.user.DefaultPhaseId)
				}, () => {
					this.setState({ otPolicyId: payGroupAndTypeHelper.getOTPolicyId(this.props.user.PayrollHierarchyItemId, this.props.user.DefaultPunchHierarchyId, this.state.defaultPunchJob, this.props.user.PayrollPayGroupId, this.props.user.OTPolicyId) })
					this.getPositions()
				})
			)
		}
		else {
			this.getPositions()
		}
	}

	getPositions(cb = null) {
		api.getPositions(this.props.user.Id, this.state.defaultPunchHierarchyId, null, this.state.defaultPunchJob && this.state.defaultPunchJob.Id, this.state.defaultPunchPhase && this.state.defaultPunchPhase.Id).then(res => {
			const positions = res.data as IPosition[]
			this.setState({
				loading: false,
				positions,
				defaultPositionId: positions.some(item => item.Id === this.state.defaultPositionId) ? this.state.defaultPositionId : null
			})
			cb && cb()
		})
	}

	getLinkedHierarchyIds() {
		return this.props.user && this.props.user.LinkedHierarchyIds ? this.props.user.LinkedHierarchyIds : []
	}

	getEmployeeHRUser(userId: string) {
		this.setState({ fetchingEmployeeHRUser: true, isFetchedEmployeeHRUser: true }, () => {
			api.getEmployeeHR(userId).then(res => {
				const EmployeeHRUser = res.data as IEmployeeHRDocument
				const latestRehireDate = this.getLatestRehireDate(EmployeeHRUser)
				this.setState({
					fetchingEmployeeHRUser: false,
					rehireDate: this.getLatestRehireDate(EmployeeHRUser),
					terminationDate: this.getLatestTerminationDate(EmployeeHRUser),  //EmployeeHRUser ? timeHelper.convertDefaultDateToNull(EmployeeHRUser.LatestTerminationDate) : null,
					seniorityDate: EmployeeHRUser ? timeHelper.convertDefaultDateToNull(EmployeeHRUser.SeniorityDate) : null,
					startDate: EmployeeHRUser ? EmployeeHRUser.DateStarted : null
				})
			})
		})
	}

	getLatestTerminationDate(employeeHR): IDate {
		if (!employeeHR || !employeeHR.TerminationDataList || employeeHR.TerminationDataList.length === 0) {
			return null
		}

		const terminationDataItem = employeeHR.TerminationDataList.sort((itemA, itemB) => itemA.Order > itemB.Order).findLast(item => item.IsTermination)
		if (!terminationDataItem) {
			return null
		}

		return timeHelper.convertDefaultDateToNull(terminationDataItem.Date)
	}

	getLatestRehireDate(employeeHR): IDate {
		if (!employeeHR || !employeeHR.TerminationDataList || employeeHR.TerminationDataList.length === 0) {
			return null
		}

		const rehireDate = employeeHR.TerminationDataList.sort((itemA, itemB) => itemA.Order > itemB.Order).findLast(item => item.IsReHire)
		if (!rehireDate) {
			return null
		}

		return timeHelper.convertDefaultDateToNull(rehireDate.Date)
		//return (employeeHR && employeeHR.RehireDates && employeeHR.RehireDates.length > 0) ? timeHelper.convertDefaultDateToNull(employeeHR.RehireDates[employeeHR.RehireDates.length - 1]) : null
	}

	saveUser(email = this.state.email) {
		if (!userHelper.checkLoggedInUserPermission(this.props.user)) return

		const linkedHierarchyIds = this.getLinkedHierarchyIds().slice()

		let user: IUserDocument = {
			FirstName: this.state.firstName.trim(),
			LastName: this.state.lastName.trim(),
			ExternalId: this.state.externalId.trim(),
			ClockPin: this.state.clockPin.trim(),
			DefaultHierarchyItemId: this.state.defaultHierarchyItemId,
			DefaultPunchHierarchyId: this.state.defaultPunchHierarchyId,
			DefaultJobId: this.state.defaultPunchJob ? this.state.defaultPunchJob.Id : null,
			DefaultJobName: this.state.defaultPunchJob ? this.state.defaultPunchJob.Name : null,
			DefaultPhaseId: this.state.defaultPunchJob && this.state.defaultPunchPhase ? this.state.defaultPunchPhase.Id : null,
			DefaultPhaseName: this.state.defaultPunchJob && this.state.defaultPunchPhase ? this.state.defaultPunchPhase.Name : null,
			RequirePhase: this.state.requirePhase,
			DefaultPositionId: this.state.defaultPositionId,
			Active: this.state.Active,
			PayrollHierarchyItemId: AccountStore.getTimecardEnabled() ? this.state.payrollHierarchyItemId : null,
			PayrollPayGroupId: this.state.payrollPayGroupId,
			PayrollPayGroupManualSet: this.state.payrollPayGroupManualSet,
			SupervisorIds: this.state.supervisorIds && this.state.supervisorIds.length ? this.state.supervisorIds : null,
			AllowPunchFromPersonalDevice: this.state.allowPunchFromPersonalDevice,
			ScheduleWeight: AccountStore.getScheduleEnabled() ? this.state.scheduleRanking : 0,
			Email: this.state.email,
			FullTime: this.state.fullTime,
			Agency: this.state.agency,
			Float: this.state.float,
			PerDiem: this.state.perDiem,
			Field1: this.state.field1,
			Field2: this.state.field2,
			Field3: this.state.field3,
			Field4: this.state.field4,
			OTPolicyId: AccountStore.getEnableOTPolicy() && this.state.otPolicyManualSet ?
				this.state.otPolicyId :
				null,
			AllowHonorTimeEntry: this.state.allowHonorTimeEntry,
			AssignJobPunch: AccountStore.getAssignJobPunchEnabled() ? this.state.assignJobPunch : false,
			Language: this.state.language,
			EnableBreadcrumb: this.state.enableBreadcrumb,
			RequireBio: this.state.requireBio,
			AllowMobileTimecardView: this.state.AllowMobileTimecardView,
			AllowMobileWorkView: this.state.AllowMobileWorkView,
			AllowMobileScheduleView: this.state.AllowMobileScheduleView,
			AllowMobileLeaveTrackingView: this.state.AllowMobileLeaveTrackingView,
			AllowMobileExpensesView: this.state.AllowMobileExpensesView,
			ESSWallet: this.state.ESSWallet,
			AllowMobileAdHocFilesView: this.state.AllowMobileAdHocFilesView,
			ApplyAutoBreaks: this.state.applyAutoBreaks,
			AllowGeoFenceNotifications: this.state.AllowGeoFenceNotifications
		}

		if (this.state.email && this.state.isAccountUser) {
			user.AccountUser = true
			user.OrganizationHierarchyId = this.state.organizationHierarchyId
			user.UserRoleId = this.state.userRoleId
		}
		else {
			user.AccountUser = false
			user.OrganizationHierarchyId = null
			user.UserRoleId = null
		}

		if (AccountStore.getExplicitEmployeeHierarchyAssignment()) {
			if (linkedHierarchyIds.indexOf(this.state.defaultHierarchyItemId) === -1) linkedHierarchyIds.push(this.state.defaultHierarchyItemId)
			user.LinkedHierarchyIds = linkedHierarchyIds
		}

		let selfServiceInfo
		if (this.state.allowSelfServiceLogin) {
			const temp = {
				UserRole: {
					Type: ELoggedInUserType.Employee,
					Permissions: [AuthenticationStore.SpecialPermission.SelfService]
				}
			}

			if (this.state.password) {
				selfServiceInfo = Object.assign(temp, { PasswordUpdate: this.state.password })
			} else {
				if (this.canSetDefaultPassword) {
					selfServiceInfo = Object.assign(temp, { PasswordUpdate: this.defaultPasword })
				} else {
					selfServiceInfo = Object.assign(temp)
				}
			}
		} else {
			selfServiceInfo = {
				PasswordUpdate: null,
				UserRole: null
			}
		}

		user = Object.assign(user, selfServiceInfo)
		this.checkValidate(user).then(result => {
			result && userActions.patchUser(this.state.id, user, () => userActions.loadUserDetails(this.props.user.Id))
		})
	}

	checkValidate(user: IUserDocument) {
		if (!userHelper.checkLoggedInUserPermission(this.props.user)) return
		let isValid = true
		if (user.FirstName.length === 0) {
			this.setState({ firstNameErrorText: strings.First_Name_cannot_be_empty })
			isValid = false
		}
		else if (user.FirstName.length > 60) {
			this.setState({ firstNameErrorText: strings.formatString(strings.it_cannot_be_longer_than_x_chars, 60) as string })
			isValid = false
		}
		else if (!utils.validateName(user.FirstName)) {
			this.setState({ firstNameErrorText: strings.only_letters_hyphens_periods_and_spaces_are_allowed })
			isValid = false
		}
		else {
			this.setState({ firstNameErrorText: "" })
		}

		if (user.LastName.length === 0) {
			this.setState({ lastNameErrorText: strings.Last_Name_cannot_be_empty })
			isValid = false
		}
		else if (user.LastName.length > 60) {
			this.setState({ lastNameErrorText: strings.formatString(strings.it_cannot_be_longer_than_x_chars, 60) as string })
			isValid = false
		}
		else if (!utils.validateName(user.LastName)) {
			this.setState({ lastNameErrorText: strings.only_letters_hyphens_periods_and_spaces_are_allowed })
			isValid = false
		}
		else {
			this.setState({ lastNameErrorText: "" })
		}

		if (!AccountStore.getExplicitEmployeeHierarchyAssignment()) {
			if (!userHelper.getEmployeeValidationForDefaultAndPunch(this.state.defaultHierarchyItemId, this.state.defaultPunchHierarchyId)) {
				this.setState({ errorDefaultPunchHierarchyId: strings.Default_cannot_be_outside_the_Punch_Permission_Hierarchy })
				isValid = false
			}
			else {
				this.setState({ errorDefaultPunchHierarchyId: "" })
			}
		}

		if (this.ChooseHierarchyJobPhaseChipForPunch && this.ChooseHierarchyJobPhaseChipForPunch.state.errorHierarchyItemId) {
			isValid = false
		}

		if (AccountStore.getTimecardEnabled()) {
			if (this.state.defaultPositionId) {
				const linkedPayTypes = payGroupAndTypeHelper.getLinkedPayTypes(payGroupAndTypeHelper.getPayGroupIdByPayrollPayGroupData({
					PayrollHierarchyItemId: this.state.payrollHierarchyItemId,
					PayrollPayGroupId: this.state.payrollPayGroupId
				}))
				const defaultPosition = this.state.positions.find(item => item && item.Id === this.state.defaultPositionId)
				const positionPayTypeid = defaultPosition.DefaultPayClass ? defaultPosition.DefaultPayClass.PayTypeId : defaultPosition.PayTypeId
				if (positionPayTypeid && !linkedPayTypes.find(item => item.Id === positionPayTypeid)) {
					this.setState({ errorDefaultPositionId: strings.Its_not_valid_for_pay_group })
					isValid = false
				}
				else {
					this.setState({ errorDefaultPositionId: "" })
				}
			}
			else {
				this.setState({ errorDefaultPositionId: "" })
			}
		}

		if (AccountStore.getEnableOTPolicy() && this.state.otPolicyIdError) {
			isValid = false
		}

		return Promise.all([this.checkEmailValidation(user.Email), this.checkExternalId(user.ExternalId), this.checkClockPin(user.ClockPin), userHelper.checkValidateSupervisors(true, this.state.supervisorIds, this.state.defaultHierarchyItemId)])
			.then(result => {
				this.setState({ errorSupervisor: result[3] })
				if (!result[0] || !result[1] || !result[2] || result[3]) isValid = false
				return isValid
			},
				() => {
					return false
				}
			)
	}

	checkExternalId(externalId) {
		let isValid = true
		if (!externalId) {
			this.setState({ externalIdErrorText: strings.Employee_ID_cannot_be_empty })
			isValid = false
		}

		if (this.props.user.ExternalId === externalId) {
			return new Promise(fulfill => fulfill(isValid))
		} else {
			return userActions.externalIdExists(AccountStore.getCurrentAccount().Id, externalId).then(
				result => {
					if (result.data) {
						this.setState({ externalIdErrorText: strings.Employee_ID_must_be_unique })
						isValid = false
					}
					return isValid
				},
				() => {
					return false
				}
			)
		}
	}

	checkClockPin(clockPin) {
		if (this.props.user.ClockPin === clockPin) {
			return new Promise(fulfill => fulfill(true))
		} else {
			return userActions.clockPinExists(AccountStore.getCurrentAccount().Id, clockPin).then(
				result => {
					if (result.data) {
						this.setState({ clockPinErrorText: strings.Clock_PIN_must_be_unique })
						return false
					} else {
						return true
					}
				},
				() => {
					return false
				}
			)
		}
	}

	async checkEmailValidation(email: string) {
		if (!email.trim())
			return true
		if (utils.validateEmail(email)) {
			this.setState({ emailErrorText: "" })
			const response = await userActions.userEmailExists(this.props.user.Id, email)
			response.data === true &&
				this.setState({ emailErrorText: strings.Email_already_in_use })
			return response.data ? false : true
		} else {
			this.setState({ emailErrorText: strings.Valid_email_required })
			return false
		}
	}

	onAllowSelfServiceLoginToggle() {
		if (this.state.allowSelfServiceLogin && !this.props.user.AccountUser) {
			this.canSetDefaultPassword = true
		}
		this.setState({
			allowSelfServiceLogin: !this.state.allowSelfServiceLogin,
			password: "",
		}, () => (!this.state.allowSelfServiceLogin || (this.state.allowSelfServiceLogin && this.state.email)) && this.saveUser())
	}

	handleEmailChange(event) {
		const email = event.target.value
		this.setState({ email })
		this.updateEmail(email)
	}

	updateEmail = _.debounce((email) => {
		this.saveUser(email)
	}, 1000)

	handleSetPasswordDialog() {
		if (!this.state.email) {
			this.setState({ emailErrorText: strings.Valid_email_required })
		} else if (!this.state.emailErrorText) {
			this.setState({ showSetPasswordDialog: !this.state.showSetPasswordDialog })
		}
	}

	savePassword(password) {
		this.handleSetPasswordDialog()
		this.setState({ password }, () =>
			this.saveUser()
		)
	}

	handleActive(active: boolean) {
		this.setState({ Active: active }, () => this.saveUser())
	}

	saveEmployee = _.debounce(() => this.saveUser(), 1000)

	render() {
		const viewCutomFieldsAllowed = permissionHelper.hasPermission(AuthenticationStore.Permissions.Employees.ViewCustomEmployeeFields)
		const editCutomFieldsAllowed = permissionHelper.hasPermission(AuthenticationStore.Permissions.Employees.EditCustomEmployeeFields)
		const customFieldLabels = AccountStore.getCurrentAccountSettings() && AccountStore.getCurrentAccountSettings().CustomFieldSettings.EmployeeCustomLabels
		return (
			<div id="UserForm">
				{this.props.loggedInUserType === ELoggedInUserType.Employee &&
					<div style={{ textAlign: "center", fontSize: 20, fontWeight: 600, marginBottom: 20, display: "flex" }}>
						{this.props.user.ProfileImageS3Url &&
							<div style={{ marginRight: 15 }}>
								<ImageLoader url={this.props.user.ProfileImageS3Url} fixedHeight={120} avatar={true} />
							</div>
						}
						<div style={{ marginTop: 20 }}>{`${this.props.user.FirstName} ${this.props.user.LastName}`}</div>
					</div>
				}
				<form autoComplete="off">
					<div style={{ display: "flex", marginTop: 20 }}>
						<TextField
							data-intercom-target={"menu-Employees-Entry-FirstName"}
							autoFocus
							floatingLabelText={strings.First_Name}
							defaultValue={this.props.user.FirstName}
							onChange={e => this.setState({ firstName: e.target.value }, () => this.saveEmployee())}
							errorText={this.state.firstNameErrorText}
							style={{ width: "100%", marginRight: 20, height: 45 }}
							floatingLabelFocusStyle={{ top: 23, fontSize: 15 }}
							floatingLabelShrinkStyle={{ top: 23, fontSize: 15 }}
							floatingLabelStyle={{ top: 16 }}
							inputStyle={{ marginTop: 5 }}
							errorStyle={{ bottom: 12, fontSize: 10 }}
							disabled={this.props.readonly || this.state.loading}
						/>
						<TextField
							data-intercom-target={"menu-Employees-Entry-LastName"}
							floatingLabelText={strings.Last_Name}
							defaultValue={this.props.user.LastName}
							onChange={e => this.setState({ lastName: e.target.value }, () => this.saveEmployee())}
							errorText={this.state.lastNameErrorText}
							style={{ width: "100%", height: 45 }}
							floatingLabelFocusStyle={{ top: 23, fontSize: 15 }}
							floatingLabelShrinkStyle={{ top: 23, fontSize: 15 }}
							floatingLabelStyle={{ top: 16 }}
							inputStyle={{ marginTop: 5 }}
							errorStyle={{ bottom: 12, fontSize: 10 }}
							disabled={this.props.readonly || this.state.loading}
						/>
					</div>
					<div style={{ display: "flex", marginTop: 10 }}>
						<TextField
							data-intercom-target={"menu-Employees-Entry-EmployeeId"}
							floatingLabelText={strings.Employee_ID}
							defaultValue={this.props.user.ExternalId}
							onChange={e =>
								this.setState({
									externalIdErrorText: "",
									externalId: e.target.value
								}, () => this.saveEmployee())
							}
							errorText={this.state.externalIdErrorText}
							style={{ width: "100%", marginRight: 20, height: 45 }}
							floatingLabelFocusStyle={{ top: 23, fontSize: 15 }}
							floatingLabelShrinkStyle={{ top: 23, fontSize: 15 }}
							floatingLabelStyle={{ top: 16 }}
							inputStyle={{ marginTop: 5 }}
							errorStyle={{ bottom: 12, fontSize: 10 }}
							maxLength="15"
							disabled={this.props.readonly || this.state.loading}
						/>
						<TextField
							data-intercom-target={"menu-Employees-Entry-ClockPin"}
							floatingLabelText={strings.Clock_PIN}
							value={this.state.clockPin}
							errorText={this.state.clockPinErrorText}
							onChange={e => (e.target.value === "" || this.clockPinRegExp.test(e.target.value)) &&
								this.setState({
									clockPinErrorText: "",
									clockPin: e.target.value
								}, () => this.saveEmployee())
							}
							style={{ width: "100%", height: 45 }}
							floatingLabelFocusStyle={{ top: 23, fontSize: 15 }}
							floatingLabelShrinkStyle={{ top: 23, fontSize: 15 }}
							floatingLabelStyle={{ top: 16 }}
							inputStyle={{ marginTop: 5 }}
							errorStyle={{ bottom: 12, fontSize: 10 }}
							maxLength="10"
							disabled={this.props.readonly || this.state.loading}
						/>
					</div>
				</form>
				{AccountStore.getHierarchyEnabled() &&
					<SettingCard
						title={strings.Punch_Default_Settings}
						error={!(!this.state.errorDefaultPunchHierarchyId && !this.state.errorDefaultPositionId)}
						style={{ marginTop: 20 }}
						expanded={this.state.expandedCardTitle === strings.Punch_Default_Settings}
						onExpandChange={expandedCardTitle => this.setState({ expandedCardTitle })}
					>
						<ChooseHierarchyChip
							ref={item => this.ChooseDefaultHierarchyItemChip = item}
							readonly={this.props.readonly || this.state.loading}
							chipLabel={strings.Punch_Permission_Hierarchy}
							hierarchyItemId={this.state.defaultHierarchyItemId}
							employee={this.props.user as IUIUser}
							getCustomNoAccessErrorStr={(selectedHierarchy: IHierarchyItem) => userHelper.getSupervisorChooseEmployeeDefaultHierarchyItemErrorStr(selectedHierarchy)}
							handleSelectHierarchy={defaultHierarchyItemId =>
								this.setState({ defaultHierarchyItemId }, () =>
									this.saveUser()
								)
							}
							customeOpenDialog={() => {
								AccountStore.getScheduleEnabled() ?
									AppStateStore.setConfirmDialogContent({
										content: strings.Changing_the_employee_hierarchy_may_impact_assigned_shifts_Would_you_like_to_proceed,
										confirm: () => this.ChooseDefaultHierarchyItemChip.setState({ openChooseHierarchyPickerDialog: true })
									}) :
									this.ChooseDefaultHierarchyItemChip.setState({ openChooseHierarchyPickerDialog: true })
							}}
							chipMaxWidth={350}
						/>
						{!AccountStore.getExplicitEmployeeHierarchyAssignment() &&
							<div data-intercom-target={`menu-Employees-${strings.Punch_Default_Settings.split(" ").join("-")}-Expandable-Panel-Select-Hierarchy-And-Job`} style={{ marginTop: 20 }}>
								<ChooseHierarchyJobPhaseChipForPunch
									ref={item => this.ChooseHierarchyJobPhaseChipForPunch = item}
									hideIcon
									ignoreNotAllowPunchSetting
									hierarchyChipLabel={strings.Default_Hierarchy}
									jobChipLabel={checkJobFieldAvailable("singular") ? `Default ${AccountStore.getCurrentAccountSettings().CustomFieldSettings.JobFieldLabels.SingularJobLabel}` : strings.Default_Job}
									phaseChipLabel={checkPhaseFieldAvailable("singular") ? `Default ${AccountStore.getCurrentAccountSettings().CustomFieldSettings.PhaseFieldLabels.SingularPhaseLabel}` : strings.Default_Phase}
									employee={{ DefaultHierarchyItemId: this.state.defaultHierarchyItemId } as IUIUser}
									readonly={this.props.readonly || this.state.loading}
									punchHierarchyItemId={this.state.defaultPunchHierarchyId}
									jobId={this.state.defaultPunchJob ? this.state.defaultPunchJob.Id : null}
									phaseId={this.state.defaultPunchPhase ? this.state.defaultPunchPhase.Id : null}
									errorHierarchyChipText={this.state.errorDefaultPunchHierarchyId}
									handleSelectHierarchyJobPhase={(hierarchyItemId, errorHierarchyItemId, job, phase, intentionalChanged) => {
										let payrollPayGroupId = this.state.payrollPayGroupId
										if (!payrollPayGroupId || (AccountStore.getEnablePayGroupAssignEmployeeLevel() && !this.state.payrollPayGroupManualSet)) {
											const userPayrollData: IUserPayrollData = {
												Id: null,
												PayrollHierarchyItemId: this.state.payrollHierarchyItemId,
												DefaultPunchHierarchyId: this.state.defaultPunchHierarchyId,
												DefaultJobId: job ? job.Id : null,
												PayrollPayGroupId: null
											}
											payrollPayGroupId = payGroupAndTypeHelper.getPayGroupIdByUserPayrollData(userPayrollData, job)
										}
										this.setState({
											defaultPunchHierarchyId: hierarchyItemId,
											defaultPunchJob: job,
											defaultPunchPhase: phase,
											payrollPayGroupId
										}, () => {
											this.getPositions(intentionalChanged && this.saveUser)
										})
									}}
									hieararchyChipMaxWidth={AccountStore.getJobsEnabled() && 350}
									jobChipMaxWidth={350}
									phaseChipMaxWidth={350}
									flexWrap
									getClickableAccessHierarchies={() => hieararchyHelper.getHierarchyIdsForShowAllChildHierarchyData(true, null)}
								/>
							</div>
						}
						{this.state.positions && this.state.positions.length > 0 &&
							<div style={{ marginTop: 20 }}>
								<PositionSelector
									positionId={this.state.defaultPositionId}
									label={checkPositionFieldAvailable('singular') ? `Default ${AccountStore.getCurrentAccountSettings().CustomFieldSettings.PositionFieldLabels.SingularPositionLabel}` : strings.DefaultPosition}
									onSave={defaultPositionId => this.setState({ defaultPositionId }, () => this.saveUser())}
									disabled={this.props.readonly || this.state.loading}
									positions={this.state.positions}
									loggedInUserType={this.props.loggedInUserType}
									floatingLabelFixed
									style={{ width: this.state.userFormWidth / 2 - 10, marginTop: -17 }}
									iconStyle={{ width: 40, top: 15 }}
									labelStyle={{ fontSize: 16, top: 12 }}
									floatingLabelStyle={{ fontSize: 15, top: 45 }}
									errorLabelFontSize={10}
									errorLabelBottomForPayInfo={-13}
									errorLabelBottomForNonPayInfo={-5}
									payInfoStyle={{ position: "absolute", fontSize: 11, top: 43 }}
									errorText={this.state.errorDefaultPositionId}
								/>
							</div>
						}
						{AccountStore.getPhasesEnabled() &&
							<Toggle
								data-intercom-target={`menu-Employees-${strings.Punch_Default_Settings.split(" ").join("-")}-Expandable-Panel-Toggle-Require-Phase`}
								disabled={this.props.readonly || this.state.loading}
								label={checkPhaseFieldAvailable("singular") ? AccountStore.getCurrentAccountSettings().CustomFieldSettings.PhaseFieldLabels.SingularPhaseLabel : strings.Require_Phase}
								onToggle={(e, requirePhase) => this.setState({ requirePhase }, () =>
									this.saveUser()
								)}
								toggled={this.state.requirePhase}
								style={{ width: 200, marginTop: 20 }}
							/>
						}
					</SettingCard>
				}
				{this.props.loggedInUserType !== ELoggedInUserType.Employee &&
					<SettingCard
						title={strings.Schedule_Payroll_Settings}
						error={false}
						expanded={this.state.expandedCardTitle === strings.Schedule_Payroll_Settings}
						onExpandChange={expandedCardTitle => this.setState({ expandedCardTitle })}
					>
						{AccountStore.getTimecardEnabled() &&
							<div
								data-intercom-target={`menu-Employees-${strings.Schedule_Payroll_Settings.split(" ").join("-")}-Expandable-Panel-Select-Payroll-Heirarchy`}
								style={{ marginTop: -10, position: "relative" }}
							>
								{!(this.props.readonly || this.state.loading) &&
									<i
										className="fa fa-edit"
										title={strings.Edit_Payroll_Settings}
										style={{ fontSize: 16, position: "absolute", right: 20, top: 10 }}
										onClick={() => this.setState({ openEditPayrollSettingsDialog: true })}
									/>
								}
								<PayrollSelection
									employeePayrollHierarchyItemId={this.state.payrollHierarchyItemId}
									employeeDefaultJob={this.state.defaultPunchJob}
									employeeDefaultPunchHierarchyItemId={this.state.defaultPunchHierarchyId}
									employeePayrollPayGroupId={this.state.payrollPayGroupId}
									employeePayrollPayGroupManualSet={this.state.payrollPayGroupManualSet}
									employeeOTPolicyId={this.state.otPolicyId}
									employeeOTPolicyManualSet={this.state.otPolicyManualSet}
									width={this.state.userFormWidth / 2 - 30}
									updateUserPayrollHierarchy
									disabled
									userId={this.props.user.Id}
									style={{ height: 65 }}
									labelStyle={{ fontSize: 16 }}
									floatingLabelStyle={{ fontSize: 15 }}
								/>
								{this.state.openEditPayrollSettingsDialog &&
									<EditPayrollSettingsDialog
										userId={this.props.user.Id}
										employeePayrollHierarchyItemId={this.state.payrollHierarchyItemId}
										employeeDefaultJob={this.state.defaultPunchJob}
										employeeDefaultPunchHierarchyItemId={this.state.defaultPunchHierarchyId}
										employeePayrollPayGroupId={this.state.payrollPayGroupId}
										employeePayrollPayGroupManualSet={this.state.payrollPayGroupManualSet}
										employeeOTPolicyId={this.state.otPolicyId}
										employeeOTPolicyManualSet={this.state.otPolicyManualSet}
										handleChange={(payrollHierarchyItemId, payrollPayGroupId, payrollPayGroupManualSet, otPolicyId, otPolicyManualSet) =>
											this.setState({
												payrollHierarchyItemId,
												payrollPayGroupId,
												payrollPayGroupManualSet,
												otPolicyId: otPolicyManualSet ? otPolicyId : null,
												otPolicyManualSet
											})
										}
										handleClose={() => this.setState({ openEditPayrollSettingsDialog: false })}
									/>
								}
							</div>
						}
						{!this.props.readonly && AccountStore.getScheduleEnabled() &&
							permissionHelper.hasPermission(AuthenticationStore.Permissions.Schedule.ViewAccountSchedule) &&
							<TextField
								data-intercom-target={`menu-Employees-${strings.Schedule_Payroll_Settings.split(" ").join("-")}-Expandable-Panel-Entry-Schedule-Ranking`}
								floatingLabelText={strings.Schedule_Ranking}
								value={this.state.scheduleRanking}
								onChange={e => utils.validateInteger(e.target.value) && this.setState({ scheduleRanking: Number(e.target.value) }, () => this.saveEmployee())}
								style={{ marginTop: 20, width: this.state.userFormWidth / 2 - (AccountStore.getEnableOTPolicy() ? 30 : 10), height: 45 }}
								floatingLabelFocusStyle={{ top: 23, fontSize: 15 }}
								floatingLabelShrinkStyle={{ top: 23, fontSize: 15 }}
								floatingLabelStyle={{ top: 16 }}
								inputStyle={{ marginTop: 13, height: 30 }}
							/>
						}
					</SettingCard>
				}
				<SettingCard
					title={strings.User_Policy}
					error={!(!this.state.errorSupervisor && !this.state.emailErrorText)}
					expanded={this.state.expandedCardTitle === strings.User_Policy}
					onExpandChange={expandedCardTitle => this.setState({ expandedCardTitle })}
				>
					{this.props.loggedInUserType !== ELoggedInUserType.Employee &&
						AccountStore.getSupervisorDirectReportEnabled() &&
						<MultiSupervisorChips
							selectedSupervisorIds={this.state.supervisorIds}
							canChooseYourSelf={this.props.user.Id !== AuthenticationStore.getLoggedInUser().Id}
							handleChange={supervisors => this.setState({ supervisorIds: supervisors.map(i => i.Id) }, () => this.saveUser())}
							readonly={
								this.props.readonly ||
								this.state.loading ||
								(
									this.state.supervisorIds && this.state.supervisorIds.length > 0 &&
									!permissionHelper.hasPermission(AuthenticationStore.Permissions.Employees.CanAddNonDirectReportEmployees)
								)
							}
							employeePermissionHierarchy={this.state.defaultHierarchyItemId}
							error={this.state.errorSupervisor}
						/>
					}
					<LanguageSelector
						readonly={this.props.readonly || this.state.loading}
						selectedLanguage={this.state.language}
						handleChange={language => this.setState({ language }, () =>
							api.setUserLanguage(this.props.user.Id, this.state.language)
						)}
					/>
					{this.props.loggedInUserType !== ELoggedInUserType.Employee &&
						<div>
							<Toggle
								data-intercom-target={`menu-Employees-${strings.User_Policy.split(" ").join("-")}-Expandable-Panel-Toggle-Active`}
								disabled={this.props.readonly || this.state.loading}
								label={strings.Active}
								onToggle={(e, value) => !value ?
									AppStateStore.setConfirmDialogContent({
										content: AccountStore.getAccrualsTimeoffEnabled() ? strings.Deleting_or_Inactivating_an_employee_will_remove_all_future_holiday_leave : strings.Deleting_or_Inactivating_an_employee_will_remove_all_future_holiday,
										confirm: () => this.handleActive(value)
									}) :
									this.handleActive(value)
								}
								toggled={this.state.Active}
								style={{ width: 275, marginTop: 10 }}
							/>
							<Toggle
								data-intercom-target={`menu-Employees-${strings.User_Policy.split(" ").join("-")}-Expandable-Panel-Toggle-Allow-Punch-From-Personal-Device`}
								disabled={this.props.readonly || this.state.loading}
								label={strings.Allow_Punch_From_Personal_Device}
								onToggle={() => this.setState({ allowPunchFromPersonalDevice: !this.state.allowPunchFromPersonalDevice }, () =>
									this.saveUser()
								)}
								defaultToggled={this.state.allowPunchFromPersonalDevice}
								style={{ width: 275, marginTop: 10 }}
							/>
							<Toggle
								data-intercom-target={`menu-Employees-${strings.User_Policy.split(" ").join("-")}-Expandable-Panel-Toggle-Require-Biometrics`}
								disabled={!AccountStore.getCurrentAccount().AccountSettings.FeatureSettings.ControlEmpBioSetting || this.props.readonly || this.state.loading}
								label={strings.Require_biometrics}
								onToggle={() => this.setState({ requireBio: !this.state.requireBio }, () =>
									this.saveUser()
								)}
								defaultToggled={this.state.requireBio}
								style={{ width: 275, marginTop: 10 }}
							/>
							<Toggle
								data-intercom-target={`menu-Employees-${strings.User_Policy.split(" ").join("-")}-Expandable-Panel-Toggle-Allow-Honor-Time-Entry`}
								disabled={this.props.readonly || this.state.loading}
								label={strings.Allow_Honor_Based_Time_Entry}
								onToggle={() => this.setState({ allowHonorTimeEntry: !this.state.allowHonorTimeEntry }, () =>
									this.saveUser()
								)}
								defaultToggled={this.state.allowHonorTimeEntry}
								style={{ width: 275, marginTop: 10 }}
							/>

							<Toggle
								data-intercom-target={`menu-Employees-${strings.User_Policy.split(" ").join("-")}-Expandable-Panel-Toggle-AllowMobileTimecardView`}
								disabled={this.props.readonly || this.state.loading}
								label={strings.AllowMobileTimecardView}
								onToggle={() => this.setState({ AllowMobileTimecardView: !this.state.AllowMobileTimecardView }, () =>
									this.saveUser()
								)}
								defaultToggled={this.state.AllowMobileTimecardView}
								style={{ width: 275, marginTop: 10 }}
							/>
							{AccountStore.getScheduleEnabled() &&
								<Toggle
									data-intercom-target={`menu-Employees-${strings.User_Policy.split(" ").join("-")}-Expandable-Panel-Toggle-AllowMobileWorkView`}
									disabled={this.props.readonly || this.state.loading}
									label={strings.AllowMobileWorkView}
									onToggle={() => this.setState({ AllowMobileWorkView: !this.state.AllowMobileWorkView }, () =>
										this.saveUser()
									)}
									defaultToggled={this.state.AllowMobileWorkView}
									style={{ width: 275, marginTop: 10 }}
								/>
							}
							{AccountStore.getScheduleEnabled() &&
								<Toggle
									data-intercom-target={`menu-Employees-${strings.User_Policy.split(" ").join("-")}-Expandable-Panel-Toggle-AllowMobileScheduleView`}
									disabled={this.props.readonly || this.state.loading}
									label={strings.AllowMobileScheduleView}
									onToggle={() => this.setState({ AllowMobileScheduleView: !this.state.AllowMobileScheduleView }, () =>
										this.saveUser()
									)}
									defaultToggled={this.state.AllowMobileScheduleView}
									style={{ width: 275, marginTop: 10 }}
								/>
							}
							{AccountStore.getAccrualsTimeoffEnabled() &&
								<Toggle
									data-intercom-target={`menu-Employees-${strings.User_Policy.split(" ").join("-")}-Expandable-Panel-Toggle-AllowMobileLeaveTrackingView`}
									disabled={this.props.readonly || this.state.loading}
									label={strings.AllowMobileLeaveTrackingView}
									onToggle={() => this.setState({ AllowMobileLeaveTrackingView: !this.state.AllowMobileLeaveTrackingView }, () =>
										this.saveUser()
									)}
									defaultToggled={this.state.AllowMobileLeaveTrackingView}
									style={{ width: 275, marginTop: 10 }}
								/>
							}
							{AccountStore.getExpensesEnabled() &&
								<Toggle
									data-intercom-target={`menu-Employees-${strings.User_Policy.split(" ").join("-")}-Expandable-Panel-Toggle-AllowMobileExpensesView`}
									disabled={this.props.readonly || this.state.loading}
									label={strings.AllowMobileExpensesView}
									onToggle={() => this.setState({ AllowMobileExpensesView: !this.state.AllowMobileExpensesView }, () =>
										this.saveUser()
									)}
									defaultToggled={this.state.AllowMobileExpensesView}
									style={{ width: 275, marginTop: 10 }}
								/>
							}
							<Toggle
								data-intercom-target={`menu-Employees-${strings.User_Policy.split(" ").join("-")}-Expandable-Panel-Toggle-ESSWallet`}
								disabled={this.props.readonly || this.state.loading}
								label={"ESS Wallet"}
								onToggle={() => this.setState({ ESSWallet: !this.state.ESSWallet }, () =>
									this.saveUser()
								)}
								defaultToggled={this.state.ESSWallet}
								style={{ width: 275, marginTop: 10 }}
							/>
							<Toggle
								data-intercom-target={`menu-Employees-${strings.User_Policy.split(" ").join("-")}-Expandable-Panel-Toggle-AllowMobileAdHocFilesView`}
								disabled={this.props.readonly || this.state.loading}
								label={strings.AllowMobileAdHocFilesView}
								onToggle={() => this.setState({ AllowMobileAdHocFilesView: !this.state.AllowMobileAdHocFilesView }, () =>
									this.saveUser()
								)}
								defaultToggled={this.state.AllowMobileAdHocFilesView}
								style={{ width: 275, marginTop: 10 }}
							/>

							{AccountStore.getJobsEnabled() && AccountStore.getAssignJobPunchEnabled() &&
								<Toggle
									data-intercom-target={`menu-Employees-${strings.User_Policy.split(" ").join("-")}-Expandable-Panel-Toggle-Assign-Job-Punch`}
									disabled={this.props.readonly || this.state.loading}
									label={strings.Punch_to_assigned_Jobs_only}
									onToggle={() => this.setState({ assignJobPunch: !this.state.assignJobPunch }, () =>
										this.saveUser()
									)}
									defaultToggled={this.state.assignJobPunch}
									style={{ width: 275, marginTop: 10 }}
								/>
							}
							{AccountStore.getEnableBreadcrumb() &&
								<Toggle
									data-intercom-target={`menu-Employees-${strings.User_Policy.split(" ").join("-")}-Expandable-Panel-Toggle-Enable-Breadcrumb`}
									disabled={this.props.readonly || this.state.loading}
									label={strings.Enable_Breadcrumb}
									onToggle={() => this.setState({ enableBreadcrumb: !this.state.enableBreadcrumb }, () =>
										this.saveUser()
									)}
									defaultToggled={this.state.enableBreadcrumb}
									style={{ width: 275, marginTop: 10 }}
								/>
							}
							<Toggle
								data-intercom-target={`menu-Employees-User-Policy-Expandable-Panel-Toggle-ApplyAutoBreaks`}
								disabled={this.props.readonly || this.state.loading}
								label={strings.Apply_Auto_Breaks}
								onToggle={() => this.setState({ applyAutoBreaks: !this.state.applyAutoBreaks }, () =>
									this.saveUser()
								)}
								defaultToggled={this.state.applyAutoBreaks}
								style={{ width: 275, marginTop: 10 }}
							/>

							{AccountStore.getGeoFenceTrackingEnabled() &&
								<Toggle
									data-intercom-target={`menu-Employees-User-Policy-Expandable-Panel-Toggle-AllowGeoFenceNotifications`}
									disabled={this.props.readonly || this.state.loading}
									label={strings.Allow_GeoFence_Notifications}
									onToggle={() => this.setState({ AllowGeoFenceNotifications: !this.state.AllowGeoFenceNotifications }, () =>
										this.saveUser()
									)}
									defaultToggled={this.state.AllowGeoFenceNotifications}
									style={{ width: 275, marginTop: 10 }}
								/>}
							{!this.props.readonly &&
								<Toggle
									data-intercom-target={`menu-Employees-${strings.User_Policy.split(" ").join("-")}-Expandable-Panel-Toggle-Self-Service-Login`}
									label={strings.Self_Service_Login}
									onToggle={this.onAllowSelfServiceLoginToggle}
									toggled={this.state.allowSelfServiceLogin}
									style={{ width: 275, marginTop: 10 }}
								/>
							}
						</div>
					}
					{(() => {
						const emailPermission = (!this.props.readonly && this.props.loggedInUserType !== ELoggedInUserType.Employee) || this.props.loggedInUserType === ELoggedInUserType.Employee
						return (
							<div style={{ display: "flex", marginTop: 5 }}>
								{(this.state.email || emailPermission) &&
									<div style={{ flex: 1 }}>
										<TextField
											data-intercom-target={`menu-Employees-${strings.User_Policy.split(" ").join("-")}-Expandable-Panel-Entry-Login-Email`}
											floatingLabelText={strings.Login_Email}
											value={this.state.email}
											errorText={this.state.emailErrorText}
											onChange={this.handleEmailChange}
											style={{ width: "100%", marginRight: 20, height: 45 }}
											floatingLabelFocusStyle={{ top: 23, fontSize: 15 }}
											floatingLabelShrinkStyle={{ top: 23, fontSize: 15 }}
											floatingLabelStyle={{ top: 16 }}
											inputStyle={{ marginTop: 5 }}
											errorStyle={{ bottom: 12, fontSize: 11 }}
											disabled={!emailPermission || this.props.user.AccountUser}
										/>
									</div>
								}
								{emailPermission &&
									<div style={{ flex: 1, textAlign: "center" }}>
										{this.state.allowSelfServiceLogin &&
											<FlatButton
												data-intercom-target={`menu-Employees-${strings.User_Policy.split(" ").join("-")}-Expandable-Panel-Btn-Set-Password`}
												label={strings.Set_Password}
												backgroundColor={AppStateStore.getFrontEndSettings().UISettings.AccentColor}
												hoverColor={AppStateStore.getFrontEndSettings().UISettings.AccentColor}
												labelStyle={{ color: "white" }}
												onClick={this.handleSetPasswordDialog}
											/>
										}
									</div>
								}
							</div>
						)
					})()}
					{!this.props.readonly && this.props.loggedInUserType !== ELoggedInUserType.Employee && this.state.allowSelfServiceLogin && this.state.email && !this.state.emailErrorText &&
						<div style={{ display: "flex", marginTop: 5 }}>
							<div style={{ flex: 1 }}>
								<Toggle
									data-intercom-target={`menu-Employees-${strings.User_Policy.split(" ").join("-")}-Expandable-Panel-Toggle-Is-Account-User`}
									label={strings.Is_Account_User}
									onToggle={(e, value) => this.setState({ isAccountUser: value, openAccountUserSettingDialog: value }, () =>
										!value && this.saveUser()
									)}
									toggled={this.state.isAccountUser}
									style={{ width: 170, marginTop: 10 }}
								/>
							</div>
							<div style={{ flex: 1, textAlign: "center" }}>
								{this.state.isAccountUser &&
									<FlatButton
										data-intercom-target={`menu-Employees-${strings.User_Policy.split(" ").join("-")}-Expandable-Panel-Btn-Settings`}
										label={strings.Settings}
										backgroundColor={AppStateStore.getFrontEndSettings().UISettings.AccentColor}
										style={{ width: 135 }}
										hoverColor={AppStateStore.getFrontEndSettings().UISettings.AccentColor}
										labelStyle={{ color: "white" }}
										onClick={() => this.setState({ openAccountUserSettingDialog: true })}
									/>
								}
							</div>
						</div>
					}
					{this.props.loggedInUserType !== ELoggedInUserType.Employee &&
						<Toggle
							data-intercom-target={`menu-Employees-${strings.User_Policy.split(" ").join("-")}-Expandable-Panel-Toggle-User-Modified`}
							label={strings.User_Modified}
							onToggle={(e, userModified) => this.setState({ userModified }, () => userActions.patchUserModified(this.props.user.Id, userModified))}
							toggled={this.state.userModified}
							style={{ width: 275, marginTop: 10 }}
							disabled={this.props.readonly}
						/>
					}
					<div style={{ marginTop: 15 }}>
						{this.state.latestFinddPrivacyPolicy &&
							<AgreementAcceptStatus
								isFinddPolicy
								agreementAcknowledgements={this.props.user.UserPrivacyAgreementAcknowledgements}
								latestAgreement={this.state.latestFinddPrivacyPolicy}
							/>
						}
						{AccountStore.getAccountAgreementEnabled() && this.state.latestAccountAgreement &&
							<AgreementAcceptStatus
								agreementAcknowledgements={this.props.user.UserPrivacyAgreementAcknowledgements}
								latestAgreement={this.state.latestAccountAgreement}
							/>
						}
					</div>
					{this.state.showSetPasswordDialog &&
						<SetPasswordDialog
							open={this.state.showSetPasswordDialog}
							savePassword={this.savePassword}
							close={this.handleSetPasswordDialog}
						/>
					}
					{this.state.openAccountUserSettingDialog &&
						<AccountUserSettingsDialog
							organizationHierarchyId={this.state.organizationHierarchyId || this.state.defaultHierarchyItemId}
							userRoleId={this.state.userRoleId}
							handleClose={() => this.setState({ openAccountUserSettingDialog: false, isAccountUser: this.state.userRoleId ? true : false })}
							handleSave={(organizationHierarchyId, userRoleId) => this.setState({ organizationHierarchyId, userRoleId, openAccountUserSettingDialog: false }, () =>
								this.saveUser()
							)}
						/>
					}
				</SettingCard>
				{
					this.props.loggedInUserType !== ELoggedInUserType.Employee &&
					<SettingCard
						title={strings.User_Information}
						error={!(!this.state.errorSupervisor && !this.state.emailErrorText)}
						expanded={this.state.expandedCardTitle === strings.User_Information}
						onExpandChange={expandedCardTitle => this.setState({ expandedCardTitle })}
					>
						{this.state.fetchingEmployeeHRUser ?
							<div className="spinner"><CircularProgress /></div> :
							<div>
								<TextField
									data-intercom-target={`menu-Employees-${strings.User_Information.split(" ").join("-")}-Expandable-Panel-Entry-User-Hire-Date`}
									floatingLabelText={strings.Hire_Date}
									value={this.state.hireDate != null ? moment(this.state.hireDate).utc().format("MM/DD/YYYY") : strings.No_Hire_Date}
									style={{ width: this.state.userFormWidth / 2 - 10, height: 45 }}
									floatingLabelFocusStyle={{ top: 23, fontSize: 15 }}
									floatingLabelShrinkStyle={{ top: 23, fontSize: 15 }}
									floatingLabelStyle={{ top: 16 }}
									inputStyle={{ marginTop: 13, height: 30 }}
									disabled={true}
								/>

								{AccountStore.getHREnabled() &&
									[
										<TextField
											data-intercom-target={`menu-Employees-${strings.User_Information.split(" ").join("-")}-Expandable-Panel-Entry-User-ReHire-Date`}
											key={"Rehire_Date"}
											floatingLabelText={strings.Latest_rehire_Date}
											value={this.state.rehireDate != null ? moment(this.state.rehireDate).utc().format("MM/DD/YYYY") : strings.No_Rehire_Date}
											style={{ width: this.state.userFormWidth / 2 - 10, height: 45 }}
											floatingLabelFocusStyle={{ top: 23, fontSize: 15 }}
											floatingLabelShrinkStyle={{ top: 23, fontSize: 15 }}
											floatingLabelStyle={{ top: 16 }}
											inputStyle={{ marginTop: 13, height: 30 }}
											disabled={true}
										/>,
										<TextField
											data-intercom-target={`menu-Employees-${strings.User_Information.split(" ").join("-")}-Expandable-Panel-Entry-Termination-Date`}
											key={"Termination_Date"}
											floatingLabelText={strings.Termination_Date}
											value={this.state.terminationDate != null ? moment(this.state.terminationDate).utc().format("MM/DD/YYYY") : strings.No_Termination_Date}
											style={{ width: this.state.userFormWidth / 2 - 10, height: 45 }}
											floatingLabelFocusStyle={{ top: 23, fontSize: 15 }}
											floatingLabelShrinkStyle={{ top: 23, fontSize: 15 }}
											floatingLabelStyle={{ top: 16 }}
											inputStyle={{ marginTop: 13, height: 30 }}
											disabled={true}
										/>,
										<TextField
											data-intercom-target={`menu-Employees-${strings.User_Information.split(" ").join("-")}-Expandable-Panel-Entry-Seniority-Date`}
											key={"Seniority_Date"}
											floatingLabelText={strings.Seniority_Date}
											value={this.state.seniorityDate != null ? moment(timeHelper.keepConvertUTCToLocal(this.state.seniorityDate)).format("MM/DD/YYYY") : strings.No_Seniority_Date}
											style={{ width: this.state.userFormWidth / 2 - 10, height: 45 }}
											floatingLabelFocusStyle={{ top: 23, fontSize: 15 }}
											floatingLabelShrinkStyle={{ top: 23, fontSize: 15 }}
											floatingLabelStyle={{ top: 16 }}
											inputStyle={{ marginTop: 13, height: 30 }}
											disabled={true}
										/>,
										<TextField
											data-intercom-target={`menu-Employees-${strings.User_Information.split(" ").join("-")}-Expandable-Panel-Entry-FTE-Ration`}
											key={"FTE_Ration"}
											floatingLabelText={strings.FTERatio}
											value={this.state.FTERatio}
											style={{ width: this.state.userFormWidth / 2 - 10, height: 45 }}
											floatingLabelFocusStyle={{ top: 23, fontSize: 15 }}
											floatingLabelShrinkStyle={{ top: 23, fontSize: 15 }}
											floatingLabelStyle={{ top: 16 }}
											inputStyle={{ marginTop: 13, height: 30 }}
											disabled={true}
										/>,
										<TextField
											data-intercom-target={`menu-Employees-${strings.User_Information.split(" ").join("-")}-Expandable-Panel-Entry-Start-Date`}
											key={"Start_Date"}
											floatingLabelText={strings.Start_Date}
											value={this.state.startDate != null ? moment(this.state.startDate).utc().format("MM/DD/YYYY") : strings.No_Start_Date}
											style={{ width: this.state.userFormWidth / 2 - 10, height: 45 }}
											floatingLabelFocusStyle={{ top: 23, fontSize: 15 }}
											floatingLabelShrinkStyle={{ top: 23, fontSize: 15 }}
											floatingLabelStyle={{ top: 16 }}
											inputStyle={{ marginTop: 13, height: 30 }}
											disabled={true}
										/>

									]
								}
								<Toggle
									data-intercom-target={`menu-Employees-${strings.User_Information.split(" ").join("-")}-Expandable-Panel-Toggle-Exempt`}
									disabled={this.props.readonly || this.state.loading}
									label={strings.Exempt}
									onToggle={() => this.setState({ fullTime: !this.state.fullTime }, () =>
										this.saveUser()
									)}
									defaultToggled={this.state.fullTime}
									style={{ marginTop: 10, width: this.state.userFormWidth / 2 - 10 }}
								/>

								<SelectField
									style={{ width: this.state.userFormWidth / 2 - 30, height: 65 }}
									data-intercom-target={`menu-Employees-${strings.User_Information.split(" ").join("-")}-Expandable-Panel-Menu-User-Type`}
									labelStyle={{ fontSize: 16 }}
									floatingLabelStyle={{ fontSize: 15 }}
									floatingLabelText={strings.Employee_Type}
									value={!this.state.agency && !this.state.float && !this.state.perDiem ? 0 : (this.state.float ? 1 : (this.state.perDiem ? 2 : 3))}
									disabled={this.props.readonly || this.state.loading}
									onChange={(event, key, value) => {
										switch (value) {
											case 0: {
												this.setState({ agency: false, float: false, perDiem: false }, () => this.saveUser())
												break;
											} case 1: {
												this.setState({ agency: false, float: true, perDiem: false }, () => this.saveUser())
												break;
											} case 2: {
												this.setState({ agency: false, float: false, perDiem: true }, () => this.saveUser())
												break;
											} case 3: {
												this.setState({ agency: true, float: false, perDiem: false }, () => this.saveUser())
												break;
											}
										}
									}}
								>
									<MenuItem value={0} primaryText={"Core Staff"} />
									<MenuItem value={1} primaryText={"Float Staff"} />
									<MenuItem value={2} primaryText={"Per Diem Staff"} />
									<MenuItem value={3} primaryText={"Agency Staff"} />
								</SelectField>

								{viewCutomFieldsAllowed &&
									<div style={{ display: "flex" }}>
										<div style={{ paddingRight: 20 }}>
											<TextField
												floatingLabelText={(customFieldLabels.Field1Label === null || customFieldLabels.Field1Label === undefined || customFieldLabels.Field1Label === "") ? `${strings.Custom_Field} 1` : customFieldLabels.Field1Label}
												value={this.state.field1}
												onChange={e => this.setState({ field1: e.target.value }, () => this.saveEmployee())}
												underlineDisabledStyle={{ borderBottom: "1px solid #e0e0e0" }}
												disabled={!editCutomFieldsAllowed}
											/>
											<TextField
												floatingLabelText={(customFieldLabels.Field2Label === null || customFieldLabels.Field2Label === undefined || customFieldLabels.Field2Label === "") ? `${strings.Custom_Field} 2` : customFieldLabels.Field2Label}
												value={this.state.field2}
												onChange={e => this.setState({ field2: e.target.value }, () => this.saveEmployee())}
												underlineDisabledStyle={{ borderBottom: "1px solid #e0e0e0" }}
												disabled={!editCutomFieldsAllowed}
											/>
										</div>
										<div style={{ padding: "0px 20px" }}>
											<TextField
												floatingLabelText={(customFieldLabels.Field3Label === null || customFieldLabels.Field3Label === undefined || customFieldLabels.Field3Label === "") ? `${strings.Custom_Field} 3` : customFieldLabels.Field3Label}
												value={this.state.field3}
												onChange={e => this.setState({ field3: e.target.value }, () => this.saveEmployee())}
												underlineDisabledStyle={{ borderBottom: "1px solid #e0e0e0" }}
												disabled={!editCutomFieldsAllowed}
											/>
											<TextField
												floatingLabelText={(customFieldLabels.Field4Label === null || customFieldLabels.Field4Label === undefined || customFieldLabels.Field4Label === "") ? `${strings.Custom_Field} 4` : customFieldLabels.Field4Label}
												value={this.state.field4}
												onChange={e => this.setState({ field4: e.target.value }, () => this.saveEmployee())}
												underlineDisabledStyle={{ borderBottom: "1px solid #e0e0e0" }}
												disabled={!editCutomFieldsAllowed}
											/>
										</div>
									</div>
								}
							</div>
						}
					</SettingCard>
				}
			</div >
		)
	}
}

interface ISettingCardProps {
	title: string
	error: boolean
	style?: CSSProperties
	expanded: boolean
	children: ReactNode
	onExpandChange(expandedTitle: string): void
}
const SettingCard: React.SFC<ISettingCardProps> = (props: ISettingCardProps) => {
	return (
		<Card
			data-intercom-target={`menu-Employees-${props.title.includes(" ") ? props.title.split(" ").join("-") : props.title}-Expandable-Panel`}
			style={props.style}
			expanded={props.expanded}
			onExpandChange={(expanded) => props.onExpandChange(expanded ? props.title : null)}
		>
			<CardHeader
				title={props.title}
				titleStyle={{ color: props.error && !props.expanded && red500 }}
				actAsExpander
				showExpandableButton
			/>
			<CardText
				expandable
				style={{ paddingTop: 5, paddingBottom: 10 }}
			>
				{props.children}
			</CardText>
		</Card>
	)
}
